import { CellProps } from 'react-table';
import { formatDate } from '@higo/common/lib/utils/formatDate';

export const DateCellRenderer = <T extends Record<string, unknown>>(
  props: CellProps<T, string>,
) => {
  return <div {...props}>{formatDate(props.cell.value, 'dd/MM/yyyy')}</div>;
};
